import $ from 'jquery';
import tips from './tips';
import api from './api';
import '../img/ico.png';
import { doStatistics } from './statistics';
import { deleteDuplicate, getParam } from './utils'
import { initBindEvent } from './event'
import {
  handleZhanliPopup,
  showTips,
  handleRewardPopup
} from './popup'

export const state = {
  isLogin: false,
  account: '',
  inBind: false,
  roleInfo: {
    sid: '',
    rid: '',
    sname: '',
    rname: '',
  },
  isPicked: 0, // 是否领取了活动一代金券,1为领取，0未领取
  level: 0,      //储值的等级
  nextLevelMoney: 200,//距离下一档位的差值
  pickTimes: 0,//抽奖次数
  lotteryGetIndex: [],//抽奖奖励状态:已抽中
  lotteryUnGetIndex: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],//抽奖奖励状态:还未抽中
  total: 0,//当前消耗抽奖券数量
  part3: [], //活动三的领取情况，返回的是id
  signInTimes: 0,//签到天数
  signInGifts: [],//key为领取的签到天数的礼包
  ce: 0,//是否领取了战力礼包
  nowAction: '', //绑定前的操作
  serverList: [],
  isActivityEnd: false // 活动是否已结束
};

export const init = async () => {
  await loginInit()
  await basicInit();
  initBindEvent()
  tips.init();
  doStatistics();
}

const loginInit = async () => {
  const res = await api.checkLogin();
  if (res && res.result == 1) {
    state.account = res.data.LOGIN_ACCOUNT;
    state.isLogin = true;
    loginInfoInit();
  }
}

const loginInfoInit = () => {
  $('.j-login-btn').hide();
  $('.j-account').html(`${state.account}`).show();
  $('.j-logout-btn,.j-bind').show();
}

const basicInit = async () => {
  const res = await api.getBasicInfo();
  if (res && +res.code === 1 && Object.keys(res.data).length) {
    state.isPicked = +res.data.isPicked;
    state.level = +res.data.level;
    state.nextLevelMoney = +res.data.nextLevel;
    state.pickTimes = +res.data.pickTimes;
    state.lotteryGetIndex = res.data.part2.map(Number)
    state.signInGifts = res.data.signInGifts.map(Number)
    state.total = +res.data.total
    state.part3 = res.data.part3.map(Number)
    state.ce = +res.data.ce;
    initIsActivityEnd(res.data.activityEnd)
    initFirstStoreState()
    initStoreProgress()
    initLotteryState()
    initExchangeState()
    autoFillCharInfo();
  }

  const signRes = await api.doSign()
  if (signRes && +signRes.code === 1) {
    state.signInTimes = +signRes.data.signinTimes
    initSignState()
  }
}

export const checkIsActivityEnd = () => {
  if (state.isActivityEnd) {
    showTips(tips.get('timeEnd'));
    return true
  }
  return false
}

const initIsActivityEnd = (activityEndTime) => {
  let endTime = new Date(activityEndTime.replace(/-/g, "/")).getTime();
  let now = new Date().getTime();
  if (now > endTime) {
    state.isActivityEnd = true
    return
  }
  state.isActivityEnd = false
}

export const initFirstStoreState = () => {
  if (!state.isPicked) {
    return
  }
  $('.j-award-btn').addClass('get')
}

const initStoreProgress = () => {
  $('.j-text-money').html(state.nextLevelMoney)
  state.level === 15 && $('.j-pay-tip').html('恭喜您已獲得今日所有的抽獎券，請明日再來～')
  $('.j-pay-tip').show()
  for (let i = 0; i <= state.level - 2; i++) {
    $('.j-progress-line-progress-item').eq(i).show()
  }
  for (let i = 0; i < state.level; i++) {
    $('.j-progress-item').eq(i).addClass('active')
  }
}

export const initLotteryState = () => {
  $('.j-lottery-chance').html(state.pickTimes)
  state.lotteryUnGetIndex = deleteDuplicate(state.lotteryUnGetIndex, state.lotteryGetIndex)
  state.lotteryGetIndex.forEach((item) => {
    $('.j-pool-item-award').eq(item - 1).addClass('get')
  });
}

export const initExchangeState = () => {
  $('.j-exchange-num').html(state.total)
  state.part3.forEach(item => {
    $('.j-award-item-btn').eq(item - 1).addClass('get')
  })
}

const autoFillCharInfo = async () => {
  let serverId =
    getParam('serverId') || getParam('server_id') || '';
  let roleId = getParam('roleId') || getParam('role_id') || '';
  let hitServer = false;
  if (!serverId || !roleId) {
    return;
  }

  const res = await api.getServer()
  if (res && res.data && +res.code === 1) {
    for (let i = 0; i < res.data.length; i++) {
      if (res.data[i].id == serverId) {
        $('.j-server').attr('data-sid', res.data[i].sid);
        $('.j-server').attr('data-id', res.data[i].id);
        $('.j-server').html(res.data[i].sname);
        hitServer = true;
        break;
      }
    }
    state.serverList = res.data;
    initServer()
  }

  if (hitServer && roleId) {
    let sid = $('.j-server').attr('data-sid');
    const roleRes = await api.getCharacter(sid);
    if (roleRes && roleRes.data && roleRes.data.length) {
      for (let i = 0; i < roleRes.data.length; i++) {
        if (roleRes.data[i].roleID == roleId) {
          $('.j-character').attr('data-id', roleRes.data[i].roleID);
          $('.j-character').html(roleRes.data[i].roleName);
        }
      }
    }
  }
}

const initServer = () => {
  let html = '';
  for (let i = 0; i < state.serverList.length; i++) {
    html += `
          <li class="j-server-list-item server-list-item" data-id=${state.serverList[i].id} data-sid=${state.serverList[i].sid}>${state.serverList[i].sname}</li>
          `;
  }
  $('.j-server-list').html(html);
}

export const initSignState = () => {
  $('.j-sign-num').html(state.signInTimes)
  for (let i = 1; i <= state.signInTimes; i++) {
    $(`.j-sign-reward-item-btn-${i}`).addClass('canget')
  }
  state.signInGifts.forEach(item => {
    $(`.j-sign-reward-item-${item},.j-sign-reward-item-btn-${item}`).addClass('get')
  })
}
export const checkLogin = () => {
  if (!state.isLogin) {
    gotoLogin(1);
    return false;
  }
  return true;
}

export const gotoLogin = (show) => {
  if (show) {
    alert(tips.get('noLoginAccount'));
  }
  let fLink = window.isPhone
    ? '//passport.gm99.com/?device=2&forward='
    : '//passport.gm99.com/?forward=';
  window.location.href = `${fLink}${encodeURIComponent(
    window.location.href
  )}`;
}

const checkBind = () => {
  if (state.isBind) {
    return true;
  }
  $('.j-popup').fadeOut();
  $('.j-popup-juese').fadeIn();
  return false;
}

export const checkLoginAndBind = (callbackFunction) => {
  if (checkLogin()) {
    if (checkBind()) {
      callbackFunction();
    }
  }
}

export const getBindInfo = () => {
  return {
    serverId: state.roleInfo.sid,
    roleId: state.roleInfo.rid,
    serverName: state.roleInfo.sname,
    roleName: state.roleInfo.rname,
  }
}

export const doAnimate = () => {
  $('.j-circle').addClass('play')
  setTimeout(() => {
    $('.j-circle').removeClass('play')
    handleZhanliPopup()
  }, 2000)
}

export const lotteryAnimate = () => {
  const eachAnimateLasting = 100
  let length = state.lotteryUnGetIndex.length
  let totalTime = length * 2
  let lotteryInterval = setInterval(() => {
    let randomIndex = Math.floor(Math.random() * length);
    $('.j-pool-item-award').removeClass('active')
    $('.j-pool-item-award').eq(state.lotteryUnGetIndex[randomIndex] - 1).addClass('active')
    totalTime--
    if (totalTime <= 0) {
      getLottery()
      clearInterval(lotteryInterval)
    }

  }, eachAnimateLasting)
}

export const getLottery = async () => {
  const res = await api.getLottery(getBindInfo());
  if (res && +res.code === 1) {
    state.lotteryGetIndex = res.data.part2.map(Number)
    state.pickTimes = +res.data.pickTimes
    let getIndex = +res.data.id
    initLotteryPopup(getIndex)
    $('.j-flush-btn').trigger('click')
  } else {
    showTips(tips.get(res.code));
  }
}

const initLotteryPopup = (getIndex) => {
  $('.j-pool-item-award').removeClass('active')
  $('.j-pool-item-award').eq(getIndex - 1).addClass('active')
  setTimeout(() => {
    handleRewardPopup(getIndex)
    initLotteryState()

  }, 1000)
}

export const jumpStorePage = () => {
  window.open('//mstore.gm99.com/?gameId=54')
}

export const roleInfoInit = () => {
  $('.j-bind').html(
    `${state.roleInfo.sname} - ${state.roleInfo.rname}`
  );
  $('.j-change-bind').show();
}